module.exports = __webpack_public_path__ + "79374a917fdf2115db5ed9dc9813c8c0.otf";